var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.63,
    height: 45.753,
    viewBox: "0 0 45.63 45.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.434,
    y1: 0.252,
    x2: 0.411,
    y2: 0.865,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19c3b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c2a69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M.119,0V15.4H28.511A15.4,15.4,0,0,0,13.107,0Z",
    transform: "translate(-0.119)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M104.721,0V45.693h15.4V15.4A15.4,15.4,0,0,0,104.721,0Z",
    transform: "translate(-104.721)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M4.982,81.967a17.01,17.01,0,0,0,24.056,0L4.982,57.911a17.01,17.01,0,0,0,0,24.056",
    transform: "translate(0 -57.911)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12",
    "data-name": "Groupe 12",
    transform: "translate(-590 2631.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11",
    "data-name": "Groupe 11",
    transform: "translate(590 -2631.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6",
    transform: "translate(0.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 32.173,
    height: 28.546,
    transform: "translate(-7.102 4.721) rotate(-33.614)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8",
    transform: "translate(30.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 38.124,
    height: 46.58,
    transform: "matrix(0.833, -0.554, 0.554, 0.833, -21.066, 14.004)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10",
    "data-name": "Groupe 10",
    transform: "translate(0 16.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 42.561,
    height: 42.561,
    transform: "matrix(0.833, -0.554, 0.554, 0.833, -15.814, 9.408)",
    fill: "url(#linear-gradient)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92cabd829698e9b1a7cd15a25ec067f8.svg";
export { ForwardRef as ReactComponent };